export default __webpack_public_path__ + "static/media/rented-icon.3e25604c.svg";